import Intro from './components/intro/Intro';
import About from './components/about/About';
import ProductList from './components/productList/ProductList';
import Contact from './components/contact/Contact';
import Toggle from './components/toggle/Toggle';
import { useContext } from 'react';
import { ThemeContext } from './context';
import Video from './components/video/Video';
import Stream from './components/stream/Stream';
function App() {

  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="all" style={{ backgroundColor: darkMode ? '#1f1f1f' : 'white', color: darkMode && 'white', }}>
      <header>
        <Toggle />
        <Intro />
        <About />
        <ProductList />
        <Stream />
        <Video embedId="W9LSgiFUXr4" />
        <Contact />
      </header>
    </div>
  );
}

export default App;
